import monitoreoDeVisibilidad from '@base/directivas/monitoreoDeVisibilidad'; 
import tooltip from '@base/directivas/tooltip';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('monitoreo-visibilidad', monitoreoDeVisibilidad); 
  nuxtApp.vueApp.directive('tooltip', tooltip);
});